import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";
import { motion } from "framer-motion";
import { Calendar, User, Clock, ChevronLeft, Share2 } from "lucide-react";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState({});
  const [metaData, setMetaData] = useState({});

  const fetchBlogsDetail = async () => {
    try {
      const params = {
        limit: 4,
      };

      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;

        setItem(blog);
        setRelatedBlogs(relatedBlogs);
        setMetaData(blog?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const staggerContainer = {
    animate: { transition: { staggerChildren: 0.1 } },
  };

  return (
    <>
      <Breadcrump title={item?.title} middle="1" />
      <SEO meta={metaData} />

      {/* <section className="s-blog-single line-bottom-container">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="heading blog-item">
                <ul className="entry-meta">
                  <li className="entry_author">
                    <p className="entry_name text-md">
                      Post by{" "}
                      <span className="fw-medium"> {item?.author} </span>
                    </p>
                  </li>
                  <li className="br-line" />
                  <li className="entry_date">
                    <p className="text-md">{formatDate(item?.date)}</p>
                  </li>
                </ul>
              </div>
              <div className="content">
                <div className="entry_image">
                  <img src={item?.image} />
                </div>
                <div className="text">
                  <div
                    dangerouslySetInnerHTML={{ __html: item?.description }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              {relatedBlogs && relatedBlogs.length > 0 && (
                <div className="row">
                  {relatedBlogs.map((blog, index) => (
                    <div key={blog._id || index} className="col-md-12">
                      <BlogRelatedCard item={blog} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section> */}

      <div className="ax-blog-detail-section-wrapper">
        <nav className="ax-blog-detail-section-nav"></nav>

        <motion.main
          initial="initial"
          animate="animate"
          variants={staggerContainer}
          className="ax-blog-detail-section-main"
        >
          <div className="ax-blog-detail-section-layout">
            {/* LEFT */}
            <section>
               <Link to={`/blog/${item?.slug}`} className="blog-title">
               {item?.title}
             </Link>
              <motion.div variants={fadeInUp}>
                <div className="ax-blog-detail-section-meta">
                 
                  <div>
                    <User size={16} /> {item?.author}
                  </div>
                  <div>
                    <Calendar size={16} /> {formatDate(item?.date)}
                  </div>
                  {/* <div><Clock size={16}/> 6 min</div> */}
                </div>
              </motion.div>

              <motion.div className="ax-blog-detail-section-image">
                {/* <img src="https://images.unsplash.com/photo-1556228578-0d85b1a4d571" /> */}
                <img src={item?.image} />
              </motion.div>

              {/* <motion.article className="ax-blog-detail-section-content">
                <div> 
                   dangerouslySetInnerHTML={{ __html: item?.description }}</div>
              </motion.article> */}

              <div className="ax-blog-detail-section-content">
                <div dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>
            </section>

            {/* RIGHT */}
            <aside className="ax-blog-detail-section-sidebar">
              <div className="ax-blog-detail-section-card p-4 mt-5">
                {relatedBlogs && relatedBlogs.length > 0 && (
                  <div className="row g-4">
                    {relatedBlogs.map((blog, index) => (
                      <div key={blog._id || index} className="col-md-12">
                        <BlogRelatedCard item={blog} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </aside>
          </div>
        </motion.main>
      </div>
    </>
  );
}

export default DetailPage;
